import { Injectable } from '@angular/core';
import { createEvents, EventAttributes } from 'ics';
import { NotificationService } from './notification.service';
import moment from 'moment';
import { ParseDurationPipe } from '../pipes/parse-flight-duration.pipe';

@Injectable({
  providedIn: 'root'
})
export class IcsService {

  constructor(private notificationSvc: NotificationService,
              private parseDurationPipe: ParseDurationPipe) { }

  generateFlightEvents(order: any): EventAttributes[] {
    return order.flights?.map((flight) => {
      const depDateTime = `${flight.departure.date} ${flight.departure.time}`;
      const arrDateTime = `${flight.arrival.date} ${flight.arrival.time}`;

      const depMoment = moment.tz(depDateTime, 'YYYY-MM-DD HH:mm', flight.departure.timezone);
      const arrMoment = moment.tz(arrDateTime, 'YYYY-MM-DD HH:mm', flight.arrival.timezone);

      const description =
        `PNR: ${order.pnr}\n` +
        flight.segments
          .map((segment, index) =>
            `Segment ${index + 1}:\n` +
            `  Flight operated by ${segment.operatingCarrier.name}\n` +
            `  Duration: ${this.parseDurationPipe.transform(segment.detail.duration)}\n` +
            `  Flight Number: ${segment.flightNumber}\n` +
            `  Class: ${segment.detail.classOfService.cabinDesignator}`
          )
          .join('\n\n') +
        `\n\nTotal Duration: ${this.parseDurationPipe.transform(flight.duration)}`;

      return {
        title: `[${order.pnr}] Flight ${flight.departure.city} to ${flight.arrival.city}`,
        description,
        location: `${flight.departure.airportName}, Terminal ${flight.departure.terminalName}`,
        start: [
          depMoment.year(),
          depMoment.month() + 1,
          depMoment.date(),
          depMoment.hour(),
          depMoment.minute()
        ],
        end: [
          arrMoment.year(),
          arrMoment.month() + 1,
          arrMoment.date(),
          arrMoment.hour(),
          arrMoment.minute()
        ],
        status: 'CONFIRMED',
        organizer: { name: order.agent, email: order.agentEmail },
        attendees: order?.passengers?.map((p) => ({
          name: `${p.data.name} ${p.data.surname}`,
          email: p.data.email,
          rsvp: false,
          role: 'REQ-PARTICIPANT'
        })),
        alarms: [
          {
            action: 'display',
            description: 'Flight Reminder - 24h before departure',
            trigger: { hours: 24, before: true }
          }
        ]
      };
    });
  }

  downloadIcsFile(order: any) {
    const events = this.generateFlightEvents(order);

    createEvents(events, (error, value) => {
      if (error) {
        console.error('Error generating .ics file:', error);
        this.notificationSvc.error('Error', error.message);
        return;
      }

      const blob = new Blob([value], { type: 'text/calendar;charset=utf-8' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${order.id}.ics`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    });
  }

}
